import React from 'react';

const DesktopAndTabletContainer = props => {
  return <div className="br-md" {...props} />;
};

export default DesktopAndTabletContainer;
